export const FETCH_MATCH_RESULTS = 'FETCH_MATCH_RESULTS';
export const SUCCESS_FETCH_MATCH_RESULTS = 'SUCCESS_FETCH_MATCH_RESULTS';
export const FAILURE_FETCH_MATCH_RESULTS = 'FAILURE_FETCH_MATCH_RESULTS';



// WEBPACK FOOTER //
// ./js/actions/MatchResults.js